// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animated-border{position:absolute;bottom:0;height:6px;width:100%;background:#fff;transition:width .5s ease-in-out}@media (min-width:768px){.animated-border{width:0}.border-parent:hover .animated-border{width:100%!important;transition:width .5s ease-in-out}}@media (min-width:900px){.border-parent:hover .animated-border{width:104%!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
